import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'indiana-sos-admin-panel';
  currentUrl: any = '';

  constructor(router: Router, private authService: AuthService) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url != '') {
          this.currentUrl = decodeURIComponent(e.url);
        } else {
          this.currentUrl = '';
        }
      }
    });
  }

  get hideSideBar() {
    return window.location.href.includes('login') || window.location.href.includes('forgot-password');
  }

  skipToMain(event: Event): void {
    event.preventDefault();
    const mainElement = document.getElementById('main');
    if (mainElement) {
      const focusableSelector =
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
      const firstFocusable = mainElement.querySelector(
        focusableSelector
      ) as HTMLElement | null;

      if (firstFocusable) {
        firstFocusable.focus();
        firstFocusable.scrollIntoView({ block: 'start' });
        return;
      }

      mainElement.focus();
      mainElement.scrollIntoView({ block: 'start' });
    }
  }

  ngOnDestroy(): void {
    this.authService.ngOnDestroy();
  }
  
}
